function Home(){
   
    return (
    <>
      <div className="App container mt-4">
        <h1 className="mb-4">Dashboard</h1>

        <div className="row">
          {/* Member Card */}
          <div className="col-md-3">
            <div className="card text-dark bg-white mb-3">
              <div className="card-body">
                <h5 className="card-title ">Members</h5>
                <p className="card-text fs-3">0</p>
              </div>
            </div>
          </div>

          {/* Guest Card */}
          <div className="col-md-3">
            <div className="card text-dark bg-white mb-3">
              <div className="card-body">
                <h5 className="card-title">Guests</h5>
                <p className="card-text fs-3">0</p>
              </div>
            </div>
          </div>

          {/* Family Card */}
          <div className="col-md-3">
            <div className="card text-dark bg-white mb-3">
              <div className="card-body">
                <h5 className="card-title">Family</h5>
                <p className="card-text fs-3">0</p>
              </div>
            </div>
          </div>

          {/* Event Card */}
          <div className="col-md-3">
            <div className="card text-dark bg-white mb-3">
              <div className="card-body">
                <h5 className="card-title">Events</h5>
                <p className="card-text fs-3">0</p>
              </div>
            </div>
          </div>
      </div>
        </div>
    </>
  );
}


export default Home;